// Loads bundled, read-only content and converts it to app types.
// To add a country cookbook: drop a JSON file in country-cookbooks/ and list it below.
import catalogJson from './catalog.json';
import type { HolidayId } from '../src/logic/holidays';
import type { Diet, Ingredient, IngredientAisle, Utensil, UtensilAisle } from '../src/types';

export type CountryCookbook = {
  id: string;
  country: string;
  flag: string;
  title: string;
  explainer: string;
  premium: boolean;
  sections: { title: string; note: string; holiday?: HolidayId; recipeIds: string[] }[];
};

import {RAW_COOKBOOKS} from './canonical';
export {CONTENT_RECIPES,CANONICAL_VERSION} from './canonical';
export const COUNTRY_COOKBOOKS: CountryCookbook[] = RAW_COOKBOOKS.map(c => ({
  id: c.id,
  country: c.country,
  flag: c.flag,
  title: c.title,
  explainer: c.explainer,
  premium: c.premium,
  sections: c.sections.map(s => ({ title: s.title, note: s.note, ...(s.holiday ? { holiday: s.holiday as HolidayId } : {}), recipeIds: s.recipes.map(r => r.id) })),
}));

/** Recipes from cookbook sections made for a holiday, with the section they come from. */
export function holidayRecipes(id: HolidayId): { recipeId: string; cookbook: CountryCookbook; section: string }[] {
  return COUNTRY_COOKBOOKS.flatMap(cookbook =>
    cookbook.sections.filter(s => s.holiday === id).flatMap(s => s.recipeIds.map(recipeId => ({ recipeId, cookbook, section: s.title }))),
  );
}

/** Which country cookbook a content recipe belongs to. */
export function cookbookOf(id: string): CountryCookbook | undefined {
  return COUNTRY_COOKBOOKS.find(c => id.startsWith(`${c.id}/`));
}

export const CATALOG_INGREDIENTS: Record<string, Ingredient> = Object.fromEntries(
  catalogJson.ingredients.map(i => [
    i.id,
    {
      id: i.id, title: i.title, aisle: i.aisle as IngredientAisle, notDiet: i.notDiet as Diet[], synonyms: i.synonyms,
      explainer: '', builtIn: true,
    },
  ]),
);

export const CATALOG_UTENSILS: Record<string, Utensil> = Object.fromEntries(
  catalogJson.utensils.map(u => [u.id, { id: u.id, title: u.title, aisle: u.aisle as UtensilAisle, synonyms: u.synonyms, explainer: '', builtIn: true }]),
);

export const RAW_CONTENT = { catalog: catalogJson, cookbooks: RAW_COOKBOOKS };
